import React from "react";
import s from "./ChooseTemplate.module.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setTemplate, setViewType } from "../MainLayout/action";
import {
  Button,
  Paper,
  FormControlLabel,
  Switch,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import classNames from "classnames/bind";
import { SECTION } from "../../constants/constants";
import defaultTempImage from "../../static/images/default-temp.jpeg";
import classicTempImage from "../../static/images/classic-temp.jpeg";
import simpleTempImage from "../../static/images/simple-temp.jpeg";
import modernTemplate from "../../static/images/modern-temp.jpeg";
import colourTempImage from "../../static/images/colour-temp.jpeg";
import designTempImage from "../../static/images/design-temp.jpeg";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";

const ChooseTemplate = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const [template, setTemplate] = React.useState(props.templateSelected);
  const [state, setState] = React.useState({
    twoColumn: props.viewType.templateTwoColumnType,
    selectBackground: props.viewType.backgroundType,
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked || event.target.value,
    });
  };

  const handleSave = (items) => {
    props.updateCurrentTemplate(template);
    props.setOptionsType({
      templateTwoColumnType: state.twoColumn,
      backgroundType: state.selectBackground,
    });
    props.setPopOverData({
      currentTarget: null,
      content: "",
    });
    props.setSnackBarData({
      open: true,
      message: SECTION.SAVED_SECTION("Template"),
    });
  };

  const selectTemplate = (choosedTemplate) => {
    setTemplate(choosedTemplate);
  };

  return (
    <section className={s.container}>
      <div className={cx(s.heading, classes.primaryThemeColor)}>
        Choose Template
      </div>
      <section className={s.optionContainer}>
        <FormControl className={s.option}>
          <InputLabel id="demo-simple-select-label">Background Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="selectBackground"
            value={state.selectBackground}
            onChange={handleChange}
          >
            <MenuItem value={"none"}>None</MenuItem>
            <MenuItem value={"rightGradient"}>Right Gradient</MenuItem>
            <MenuItem value={"leftGradient"}>Left Gradient</MenuItem>
            <MenuItem value={"topGradient"}>Top Gradient</MenuItem>
            <MenuItem value={"bottomGradient"}>Bottom Gradient</MenuItem>
            <MenuItem value={"light"}>White</MenuItem>
            <MenuItem value={"dark"}>Dark</MenuItem>
          </Select>
        </FormControl>
        <FormControl className={cx(s.option, s.twoColumnOption)}>
          <FormControlLabel
            control={
              <Switch
                checked={state.twoColumn}
                onChange={handleChange}
                name="twoColumn"
                color="primary"
              />
            }
          />
          <FormHelperText>Use 2 Columns</FormHelperText>
        </FormControl>
      </section>
      <section className={cx(s.contentContainer, classes.secondaryTextColor)}>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "default",
            [classes.active]: template === "default",
          })}
          onClick={() => selectTemplate("default")}
        >
          <img alt="default template" src={defaultTempImage} />
          <div>Default</div>
        </Paper>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "classic",
            [classes.active]: template === "classic",
          })}
          onClick={() => selectTemplate("classic")}
        >
          <img alt="classic template" src={classicTempImage} />
          <div>Classic</div>
        </Paper>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "simple",
            [classes.active]: template === "simple",
          })}
          onClick={() => selectTemplate("simple")}
        >
          <img alt="simple template" src={simpleTempImage} />
          <div>Simple</div>
        </Paper>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "modern",
            [classes.active]: template === "modern",
          })}
          onClick={() => selectTemplate("modern")}
        >
          <img alt="modern template" src={modernTemplate} />
          <div>Modern</div>
        </Paper>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "colour",
            [classes.active]: template === "colour",
          })}
          onClick={() => selectTemplate("colour")}
        >
          <img alt="colour template" src={colourTempImage} />
          <div>Colour</div>
        </Paper>
        <Paper
          className={cx(s.template, classes.secondaryTextColor, {
            [s.active]: template === "design",
            [classes.active]: template === "design",
          })}
          onClick={() => selectTemplate("design")}
        >
          <img alt="colour template" src={designTempImage} />
          <div>Design</div>
        </Paper>
      </section>
      <div className={s.actionContainer}>
        <Button
          onClick={() => {
            handleSave();
          }}
          variant="contained"
          size="small"
          color="primary"
        >
          Select Template
        </Button>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  ...state.mainLayoutReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateCurrentTemplate: (updatedObj) => {
      setTemplate(updatedObj)(dispatch);
    },
    setOptionsType: (isTrue) => {
      setViewType(isTrue)(dispatch);
    },
    dispatch,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChooseTemplate)
);

const compClasses = (theme) => ({
  active: {
    color: theme.palette.primary.main,
  },
});
